import React, { useEffect, useState } from "react"
import { observer } from "mobx-react"
import FormStore from "../../Configs/Store/forms"
import { Modal } from "antd"
import { leadWSAPI } from "../../Configs/API"

const ORIGIN_URL = window.location.hostname === "www.iciciprulife.com" ? process.env.REACT_APP_ORIGIN_IPU : process.env.REACT_APP_ORIGIN_DEP
const SUITABILITY_URL = window.location.hostname === "www.iciciprulife.com" ?
  window.location.href.includes('testing') ? process.env.REACT_APP_SUIT_IPU_UAT : process.env.REACT_APP_SUIT_IPU_PROD : process.env.REACT_APP_SUIT_DEP


const SuitabilityModal = observer(() => {
  const [isFrameLoaded, setFrameLoaded] = useState(false)

  useEffect(() => {
    AttachReceiver()
  }, [])

  useEffect(() => {
    if (FormStore.calc_suitability && isFrameLoaded) {
      sendDataToSuitability()
    }
  }, [FormStore.calc_suitability])

  const AttachReceiver = () => {
    window.onmessage = (e) => {
      var data = e.data
      if (data.SuitParent) {
        if (data.SuitParent.closeSuitability) {
          FormStore.setSuitabilityModal(false)

          // console.info("Window Closed", data)
        } else {
          var element = document.querySelector(".SuitabilityModalRoot .ant-modal-content")
          if (element) {
            // console.info("Message :", data)
            element.style.height = data.SuitParent.height + 80 + "px"
          }
        }
        if (data.SuitParent.fireLeadWS) {
          leadWSAPI(FormStore, data.SuitParent.SuitabilityCheckBox)
        }
      }
    }
  }

  const VerfiySuitLink = (e) => {
    // console.info("VerfiySuitLink :", e)
    sendDataToSuitability()
  }

  const sharpQData = (name, query) => {
    if (!query) query = window.location.search
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]")
    var regexS = "[\\?&]" + name + "=([^&#]*)"
    var regex = new RegExp(regexS)
    var results = regex.exec(query)

    if (results === null) return ""
    else return decodeURIComponent(results[1])
  }

  const CheckQData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search)
    const params = Object.fromEntries(urlSearchParams.entries())
    var qDataTest = params["qdata"]
    if (qDataTest !== "" && qDataTest !== undefined && qDataTest !== null) {
      var decryptQdata = await sharpQData("qdata")
      return decryptQdata
    } else {
      return ""
    }
  }

  const sendDataToSuitability = async () => {
    var KEY = process.env.REACT_APP_SUIT_KEY
    var PLAIN_DATA = await CheckQData()
    PLAIN_DATA = PLAIN_DATA === "" ? {} : PLAIN_DATA
    var UserIP = window.UserInput
    var UserInputEnc = UserIP["dob"] ? window.blowfish["encrypt"](JSON.stringify(UserIP), KEY, { outputType: 0, cipherMode: 0 }) : {}
    var UI_LEN = Object.entries(UserInputEnc).length > 0
    var QDATA_LEN = Object.entries(PLAIN_DATA).length > 0
    var UID = window.Glb_UID + ""
    setTimeout(async () => {
      var Control = {
        SuitChild: {
          // Sending to Child
          type: QDATA_LEN && UI_LEN ? 0 : QDATA_LEN ? 1 : 2, // 0 ? Both Available, 1 ? QDATA Available, 2 ? UserInput Available.
          dataUP: UserInputEnc,
          dataQ: PLAIN_DATA,
          UID: UID,
        },
      }
      document.getElementById("SuitabilityBOOFrame").contentWindow.postMessage(Control, ORIGIN_URL)
      setFrameLoaded(true)
    }, 1000)
  }

  return (
    <div>
      <Modal
        visible={FormStore.calc_suitability}
        footer={null}
        centered={true}
        closable={false}
        className="SuitabilityModalRoot"
      >
        <div className="SuitabilityBOO">
          <iframe id="SuitabilityBOOFrame" scrolling="no" src={SUITABILITY_URL} title="" onLoad={VerfiySuitLink} onError={VerfiySuitLink}></iframe>
        </div>
      </Modal>
    </div>
  )
})

export default SuitabilityModal
